import React from 'react';
import { FaFacebookF, FaInstagram, FaEnvelope, FaPhoneAlt } from 'react-icons/fa';

// Komponent nagłówka sekcji w stopce dla spójności
const FooterSectionTitle = ({ children }) => (
    <p className="font-bold tracking-wide text-gray-800 uppercase text-sm mb-4">
        {children}
    </p>
);

// Komponent pojedynczego linku w stopce dla czystszego kodu
// ZMIANA: Dodano 'text-sm' dla spójności
const FooterLink = ({ href, children }) => (
    <li>
        <a
            href={href}
            className="text-sm text-gray-600 transition-colors duration-300 hover:text-[#795b40]"
        >
            {children}
        </a>
    </li>
);

const Footer = () => {
    // Dane do linków - łatwiejsze zarządzanie w jednym miejscu
    const quickLinks = [
        { href: '/', label: 'Strona Główna' },
        { href: '/o-nas', label: 'O nas' },
        { href: '/realizacje', label: 'Realizacje' },
        { href: '/kontakt', label: 'Kontakt' },
    ];

    const legalLinks = [
        { href: '/polityka-prywatnosci', label: 'Polityka Prywatności' },
        { href: '/polityka-cookies', label: 'Polityka Cookies' },
    ];

    return (
        <footer className="bg-gray-50 border-t border-gray-200">
            <div className="container mx-auto px-6 py-12 lg:px-8">
                {/* Górna część stopki z kolumnami */}
                <div className="grid gap-12 row-gap-8 mb-10 sm:grid-cols-2 lg:grid-cols-4">

                    {/* Kolumna 1: O firmie i social media */}
                    <div className="sm:col-span-2 lg:col-span-1">
                        <a href="/" aria-label="Idź do strony głównej" className="inline-block">
                            {/* ZMIANA: Zmniejszono wielkość i wagę czcionki dla lepszej harmonii */}
                            <h3 className="text-lg font-semibold text-gray-800">HakunaHouse.pl</h3>
                        </a>
                        <p className="mt-4 text-sm text-gray-600">
                            Specjalizujemy się w tworzeniu wyjątkowych domów, łącząc nowoczesny design z funkcjonalnością.
                        </p>
                        <div className="mt-6 flex items-center space-x-4">
                            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-500 hover:text-[#795b40] transition-colors">
                                <FaFacebookF className="h-5 w-5" /> {/* Lekkie zmniejszenie ikon */}
                            </a>
                            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-500 hover:text-[#795b40] transition-colors">
                                <FaInstagram className="h-5 w-5" /> {/* Lekkie zmniejszenie ikon */}
                            </a>
                        </div>
                    </div>

                    {/* Kolumna 2: Szybka nawigacja */}
                    <div>
                        <FooterSectionTitle>Szybka Nawigacja</FooterSectionTitle>
                        <ul className="space-y-2">
                            {quickLinks.map(link => (
                                <FooterLink key={link.label} href={link.href}>
                                    {link.label}
                                </FooterLink>
                            ))}
                        </ul>
                    </div>

                    {/* Kolumna 3: Informacje prawne */}
                    <div>
                        <FooterSectionTitle>Informacje</FooterSectionTitle>
                        <ul className="space-y-2">
                            {legalLinks.map(link => (
                                <FooterLink key={link.label} href={link.href}>
                                    {link.label}
                                </FooterLink>
                            ))}
                        </ul>
                    </div>

                    {/* Kolumna 4: Kontakt */}
                    <div>
                        <FooterSectionTitle>Kontakt</FooterSectionTitle>
                        <ul className="space-y-3 text-sm text-gray-600">
                            <li className="flex items-center"> {/* zmienione na items-center dla lepszego wyrównania */}
                                <FaPhoneAlt className="text-gray-500 mr-3 flex-shrink-0" />
                                {/* POPRAWKA: Dodano funkcjonalny link 'tel:' */}
                                <a href="tel:+48604093352" className="hover:text-[#795b40]">+48 604 093 352</a>
                            </li>
                            <li className="flex items-center">
                                <FaEnvelope className="text-gray-500 mr-3 flex-shrink-0" />
                                {/* POPRAWKA: Dodano funkcjonalny link 'mailto:' */}
                                <a href="mailto:kontakt@hakunahouse.pl" className="hover:text-[#795b40]">kontakt@hakunahouse.pl</a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Dolna część stopki z prawami autorskimi */}
                <div className="flex flex-col-reverse justify-between items-center pt-5 pb-2 border-t lg:flex-row">
                    <p className="text-sm text-gray-600 mt-4 lg:mt-0">
                        © {new Date().getFullYear()} HakunaHouse.pl. Wszelkie prawa zastrzeżone.
                    </p>

                    {/* POPRAWKA: Dodano przykładowy link */}
                    <a
                        href="https://siteify.dev"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-gray-600 transition-colors duration-300 hover:text-[#795b40]"
                    >
                        Realizacja: Siteify
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;